import React from "react";
import { Link } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Bookmark, BookmarkX } from "lucide-react";
import { useLearn } from "@/contexts/LearnContext";
import { Button } from "@/components/ui/button";

export default function BookmarksDrawer() {
  const { bookmarks, toggleBookmark } = useLearn();

  return (
    <Sheet>
      <SheetTrigger asChild>
        <button
          type="button"
          data-testid="bookmarks-trigger"
          aria-label="Open bookmarks"
          className="inline-flex items-center justify-center h-10 w-10 rounded-full border border-border hover:border-primary hover:text-primary transition-colors relative"
        >
          <Bookmark size={18} />
          {bookmarks.length > 0 && (
            <span className="absolute -top-1 -right-1 bg-primary text-primary-foreground text-[10px] font-semibold rounded-full h-5 w-5 flex items-center justify-center">
              {bookmarks.length}
            </span>
          )}
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[360px] sm:w-[420px]">
        <SheetHeader>
          <SheetTitle className="font-serif text-2xl">Your Bookmarks</SheetTitle>
          <p className="text-sm text-muted-foreground">
            Quick access to sub-topics you've saved.
          </p>
        </SheetHeader>

        <div className="mt-6 space-y-3">
          {bookmarks.length === 0 && (
            <div className="text-sm text-muted-foreground italic py-10 text-center border border-dashed border-border rounded">
              No bookmarks yet. Tap the bookmark icon on any sub-topic to save it.
            </div>
          )}
          {bookmarks.map((b) => (
            <div
              key={`${b.module_id}-${b.subtopic_id}`}
              className="border border-border rounded p-3 flex items-start justify-between gap-3 hover:border-primary transition-colors"
              data-testid={`bookmark-${b.subtopic_id}`}
            >
              <Link
                to={`/module/${b.module_id}#${b.subtopic_id}`}
                className="flex-1 text-sm font-medium hover:text-primary"
              >
                {b.subtopic_title}
              </Link>
              <Button
                size="icon"
                variant="ghost"
                className="h-7 w-7"
                onClick={() => toggleBookmark(b.module_id, b.subtopic_id, b.subtopic_title)}
                aria-label="Remove bookmark"
                data-testid={`remove-bookmark-${b.subtopic_id}`}
              >
                <BookmarkX size={14} />
              </Button>
            </div>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
}
